import { Entity } from "typeorm";

import { ChangeLogs } from "./ChangeLogs";

@Entity("apiPartnerChangeLogs")
export class ApiPartnerChangeLog extends ChangeLogs {}
